import React from 'react';
import ReactDOM from 'react-dom';
import App from '@elevio/kb-kit/lib/App';
import config from './config';
import './css/main.css';
const target = document.getElementById('kb-target');
if (!target)
    throw new Error('Cant find target div');
if (!document.title.trim()) {
    document.title = 'Pasquotank Knowledge Base';
}
target.setAttribute('role', 'main');
target.setAttribute('aria-label', 'Knowledge base content');
const rootLandmarkObserver = new MutationObserver(() => {
    if (target.querySelector('main.page, main.main')) {
        target.removeAttribute('role');
        target.removeAttribute('aria-label');
        rootLandmarkObserver.disconnect();
    }
});
rootLandmarkObserver.observe(target, { childList: true, subtree: true });
ReactDOM.render(<App config={config}/>, target);
// Initialize axe-core for accessibility testing in development mode
if (process.env.NODE_ENV !== 'production') {
    import('@axe-core/react').then((axe) => {
        axe.default(React, ReactDOM, 1000);
    }).catch((error) => {
        console.error('Failed to load axe-core/react:', error);
    });
}
